/* ==========================================================================
   SearcherFlightHotel > Client
   ========================================================================== */

/* Import modules */
const { elementExist } = require('@bluekiri/alexandria/helpers/domHelpers');
const { initAutocomplete } = require('./autocomplete');
const { initCalendar } = require('./calendar');
const { initAccommodation } = require('./accommodation');
const { initDiscounts } = require('./discounts');
const { initClass } = require('./class');
const { initLoading } = require('./loading');
const { initButton } = require('./button');
const prototype = require('./prototype');
const config = require('./config');

/**
 * Searcher component
 * @param {selector} String selector for the component in the client side.
 */
module.exports = function SearcherFlightHotel(selector = '[data-component="SearcherFlightHotel"]') {
    if (elementExist(selector)) {
        // Instance reference
        const instance = Object.create(prototype);
        const configuration = config();

        // Element reference
        instance.element = document.querySelector(selector);

        instance.config = {
            ...config(),
            ...(function Fn() {
                const result = JSON.parse(instance.element.dataset.config);
                instance.element.dataset.config = '';
                return result;
            })()
        };

        /* Element loadingData */
        instance.loadingData = JSON.parse(instance.element.dataset.loading);

        // Autocomplete
        instance.location = initAutocomplete(selector, instance, {
            ...configuration.location
        });

        // Update Operative Destination
        instance.updateDestination(instance);

        // Calendar
        instance.calendar = initCalendar(
            `${selector} [data-component="Calendar"][data-type="calendar"]`,
            { ...configuration.calendar },
            instance
        );

        // Calendar Footer
        instance.setFooterCalendar(instance);

        // Passenger accommodation panel with input synced
        instance.accommodation = initAccommodation(selector, instance);

        // Class
        initClass(selector, instance);

        // Discounts
        initDiscounts(selector, instance);

        /* Loading */
        instance.loading = initLoading(selector, { ...instance.config.loading }, instance);

        // Submit button
        instance.submit = initButton(
            `${selector} [data-component="Button"][data-type="${config().type.submit}"]`,
            instance
        );

        return instance;
    }
};
